.gc{z-index:2;}